import type { ISeverity } from '@/types/severity'
import { SEVERITIES as SEVERITIES_CONSTANTS } from '@/lib/constants/severities'
export const SEVERITIES: Record<ISeverity, string> = {
  [SEVERITIES_CONSTANTS.CRITICAL]: 'Crítico',
  [SEVERITIES_CONSTANTS.HIGH]: 'Alto',
  [SEVERITIES_CONSTANTS.MEDIUM]: 'Medio',
  [SEVERITIES_CONSTANTS.LOW]: 'Bajo',
} as const
